import { createContext, useContext } from 'react';

/// Abrir o fechamento de um atendimento (ADR 0030). A página vive na composição, que é quem sabe o
/// endereço; a agenda só pede para abrir. Sem provedor, a ação não aparece.
const context = createContext<((appointmentId: string) => void) | undefined>(undefined);

export const ClosingLinkProvider = context.Provider;

export function useOpenClosing(): ((appointmentId: string) => void) | undefined {
  return useContext(context);
}

/// Abrir o Prontuário da cliente a partir do agendamento (ADR 0038, adendo de 2026-09-28). A
/// composição abre o painel lateral; sem provedor — sem Prontuário ou sem permissão —, a ação não
/// aparece.
const chartContext = createContext<((clientId: string) => void) | undefined>(undefined);

export const ChartLinkProvider = chartContext.Provider;

export function useOpenChart(): ((clientId: string) => void) | undefined {
  return useContext(chartContext);
}
